import { ethers } from 'ethers';

import { CONTRACTS } from '#models/contracts/constants';

export const getProvider = () =>
  new ethers.providers.WebSocketProvider(process.env.REACT_APP_NETWORK_PROVIDER_WEBSOCKET);

export const getAllEvents = async ({ event, contractName }) => {
  // TODO: handle errors and error response
  if (!process.env.REACT_APP_NETWORK_PROVIDER_WEBSOCKET) {
    return { ok: false };
  }
  const { ADDRESS, ABI } = CONTRACTS[contractName];
  const provider = getProvider();
  const contract = new ethers.Contract(ADDRESS, ABI, provider);
  const data = await contract.queryFilter(event);
  return { ok: !!data, data };
};

// TODO: Check if metamask is logged in
export const execFunction = async ({ contractName, functionName, functionParams }) => {
  const { ADDRESS, ABI } = CONTRACTS[contractName];
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider?.getSigner();
  const contract = new ethers.Contract(ADDRESS, ABI, signer);
  const transactionResponse = await contract?.[functionName](...functionParams)
    .then(() => ({ ok: true }))
    .catch(() => ({ ok: false }));
  return { ok: transactionResponse?.ok };
};
